<template>
  <div class="view pa24">
    <div class="d-flex mb20">
      <div class="bgf7fa pt20 pr20 pl20 pb20 d-flex flex-column mr20 w600">
        <p>{{ $t('turnToIntroduce', 'memberName') }}：{{memberInfo.name}}</p>
        <p>{{ $t('turnToIntroduce', 'partnerCount') }}：{{memberInfo.partnerNum}}</p>
        <p>{{ $t('turnToIntroduce', 'totalReferralCustomers') }}：{{memberInfo.customerNum}}</p>
        <p>{{ $t('turnToIntroduce', 'successfulCustomers') }}：{{memberInfo.customerNum}}</p>
        <p>{{ $t('turnToIntroduce', 'totalTransactionAmount') }}：{{memberInfo.shopSell + memberInfo.manualSell}}</p>
        <p>{{ $t('turnToIntroduce', 'promotionRewardExpense') }}：{{memberInfo.partnerRate + memberInfo.partnerRateWait}} </p>
      </div>
      <div class="bgf7fa pt20 pr20 pl40 d-flex  mr20 w250">
        <div class="d-flex flex-column align-items-center pt20 mr100">
          <div class="mb20">{{ $t('turnToIntroduce', 'memberInvitationCode') }}</div>
          <div class="d-flex fwbold align-items-center cA1 fs8">
            {{memberInfo.partnerKey || $t('turnToIntroduce', 'noInvitationCode')}}
            <i class="el-icon-document-copy ml20 " @click="copyTemplate(memberInfo.partnerKey)"></i>
          </div>
        </div>
        <!-- <div class="d-flex flex-column align-items-center pt18">
          <div class="mb18">{{ $t('turnToIntroduce', 'invitationQRCode') }}</div>
          <div class="d-flex cblue fs8 hover_pointer" @click="queryCode">
            {{ $t('turnToIntroduce', 'clickToView') }}
          </div>
        </div> -->
      </div>
    </div>
    
    <div class="d-flex align-items-center">
      {{ $t('turnToIntroduce', 'partnerName') }}：<el-input class="mr20 w200"  v-model="keyword" :placeholder="$t('turnToIntroduce', 'pleaseEnterPartnerName')"></el-input>
      {{ $t('turnToIntroduce', 'phoneNumber') }}：<el-input class="mr20 w200"  v-model="phone" :placeholder="$t('turnToIntroduce', 'pleaseEnterPhoneNumber')"></el-input>
      <el-date-picker
        v-model="pickerValue"
        class="mr10 "
        align="right"
        value-format="yyyy-MM-dd"
        type="daterange"
        :start-placeholder="$t('turnToIntroduce', 'startDate')"
        :end-placeholder="$t('turnToIntroduce', 'endDate')"
      />
      
      <el-button type="primary" @click="queryVisitorsData">{{ $t('turnToIntroduce', 'search') }}</el-button>
      <!-- <el-button type="primary" @click="queryVisitorsData">{{ $t('turnToIntroduce', 'export') }}</el-button> -->
    </div>
    
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
            prop="name"
            align="center"
            :label="$t('turnToIntroduce', 'partnerName')"
            show-overflow-tooltip
          />
        <el-table-column prop="phone" align="center" :label="$t('turnToIntroduce', 'phoneNumber')" />
        <el-table-column prop="createdTime" show-overflow-tooltip align="center" :label="$t('turnToIntroduce', 'becomePartnerTime')" />
        <el-table-column prop="customerNum" align="center" :label="$t('turnToIntroduce', 'totalReferralCustomers')" />
        <el-table-column prop="notTrading" align="center" :label="$t('turnToIntroduce', 'unfollowedCustomers')" />
        <el-table-column prop="customerFollowNum" align="center" :label="$t('turnToIntroduce', 'followedCustomers')" />
        <el-table-column prop="customerSuccNum" align="center" :label="$t('turnToIntroduce', 'successfulCustomers')" />
        <el-table-column prop="manualSell" align="center" :label="$t('turnToIntroduce', 'manualTransactionAmount')" />
        <el-table-column prop="shopSell" align="center" :label="$t('turnToIntroduce', 'mallTransactionAmount')" />
        <el-table-column prop="partnerRate" align="center" :label="$t('turnToIntroduce', 'totalPromotionReward')" />
        <el-table-column prop="balance" align="center" :label="$t('turnToIntroduce', 'withdrawableReward')" />
        <el-table-column prop="withdrawalsWait" align="center" :label="$t('turnToIntroduce', 'withdrawingReward')" />
        <el-table-column prop="visitTime" width="150" align="center" :label="$t('turnToIntroduce', 'operation')">
          <template slot-scope="scope">
            <div class="d-flex">
              <p class="cred hover_pointer mr20" @click="releaseRelationship(scope.row)">{{ $t('turnToIntroduce', 'releaseRelationship') }}</p>
              <p class="cblue hover_pointer" @click="toDetailPage(scope.row)">{{ $t('turnToIntroduce', 'details') }}</p>
            </div>
            
          </template>
        </el-table-column>
        
      </template>
    </commonTable>
    <el-dialog :title="$t('turnToIntroduce', 'invitationQRCode')" 
               width="20%"
               :center="true"
               :modal-append-to-body="false"
               :visible="QrCodeVisible"
               @close="dialogClose">
         <img :src="QrCodeImg" class="w100p h100p">
    </el-dialog>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { getDataTimeSec,copyText } from "@/utils";
import {  
  queryPartnerList,
  queryInvitationCode,
  employeeDetails,
  dismiss
} from "@/api/turnToIntroduce";
import i18nMixin from '@/mixins/i18nMixin';
 
export default {
  name: "visitorData",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      pickerValue: "", //选择时间
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      staffs: [],
      userId: "",
      sourcesId: "",
      authsId: "",
      phone: "",
      startTime: this.startTime,
      endTime: this.endTime,
      totalSells:0, //收入合计
      totalPrice:0, //累计商品收入
      totalCommission:0 ,//累计佣金
      keyword:'',
      memberInfo:"",
      QrCodeVisible:false,
      QrCodeImg:'',
    };
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  created() {
    console.log(this.$route.query.id)
    this.queryVisitorsData()
    this.employeeDetails()
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    async queryVisitorsData() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        empId:this.$route.query.id,
        phone: this.phone,
        name:this.keyword,
        startTime: this.pickerValue && `${this.pickerValue[0]} 00:00:00`,
        endTime: this.pickerValue && `${this.pickerValue[1]} 23:59:59`,
      };
      
      try {
        this.loading = true;
        const result = await queryPartnerList(data);
        this.loading = false;
        // 添加安全检查，确保pageInfo存在
        if (result?.data?.pageInfo) {
          const { total, list } = result.data.pageInfo;
          this.tableData = list;
          this.tableData.forEach(item=>{
            item.notTrading = item.customerNum - item.customerFollowNum
            //item.aggregateAmount = item.manualSell + item.shopSell
            item.moneyReward = item.partnerRate + item.partnerRateWait
          })
          this.total = total;
        } else {
          // 如果没有pageInfo，设置默认值
          this.tableData = [];
          this.total = 0;
        }
      } catch (error) {
        this.tableData = []
        this.loading = false;
        console.log(error);
      }
    },
    copyTemplate(key){
      if(!key){
        return
      }
      copyText(key);
      this.$message.success(this.$t('turnToIntroduce', 'copySuccess'));
    },
    // formatSeconds(value) {
    //   var theTime = parseInt(value);// 秒
    //   var theTime1 = 0;// 分
    //   var theTime2 = 0;// 小时
    //   if(theTime > 60) {
    //     theTime1 = parseInt(theTime/60);
    //     theTime = parseInt(theTime%60);
    //     if(theTime1 > 60) {
    //       theTime2 = parseInt(theTime1/60);
    //       theTime1 = parseInt(theTime1%60);
    //     }
    //   }
    //   var result = ""+parseInt(theTime)+"秒";
    //   if(theTime1 > 0) {
    //     result = ""+parseInt(theTime1)+"分"+result;
    //   }
    //   if(theTime2 > 0) {
    //     result = ""+parseInt(theTime2)+"小时"+result;
    //   }
    //   return result;
    // },
    employeeDetails(){
      let data = {
        empId:this.$route.query.id
      }
      employeeDetails(data)
      .then(res=>{
        console.log(res)
        if(res && res.data){
          this.memberInfo = res.data
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryVisitorsData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryVisitorsData();
    },
    toDetailPage(item){
      this.$router.push({ path:`/partnerListDetail?empId=${item.empId}&userId=${item.userId}&epId=${item.epId}` });
    },
    dialogClose(){
      this.QrCodeVisible = false
    },
    releaseRelationship(item){
      let than
      this.$confirm(this.$t('turnToIntroduce', 'releaseRelationshipConfirm'), this.$t('turnToIntroduce', 'releaseRelationshipTitle'), {
        confirmButtonText: this.$t('turnToIntroduce', 'confirm'),
        cancelButtonText: this.$t('turnToIntroduce', 'cancel'),
      }).then(() => {
        let data ={
          empId:item.empId,
          userId:item.userId,
        }
        dismiss(data)
        .then(res=>{
          if(res.code == 200){
            this.$message.success(this.$t('turnToIntroduce', 'releaseSuccess')) 
            this.queryVisitorsData()
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('turnToIntroduce', 'operationCancelled')
        });          
      });
    },
    queryCode(){
      let data = {
        userId:this.memberInfo.userId
      }
      queryInvitationCode(data)
      .then(res=>{
        this.QrCodeImg = res.data
        if(this.QrCodeImg){
          this.QrCodeVisible = true
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
</style>